import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { AUTH_CUSTOMER_MODULE_NAME } from "@nxplatform/platform-entities";
import { selectResponsibleGamblingTools } from "@nxplatform/platform-settings/brand-settings.slice";
import { allowedLinks } from "@nxplatform/platform-settings/locale-setup.routes";
import { useQuery } from "../../hooks/query.hook.js";
import { selectModuleLoaded } from "@nxplatform/store-utils/module-manager/module-manager.slice";
const useUserLimitToken = ({
  limitTokenSuccess,
  checkLimitToken
}) => {
  var _a;
  const navigate = useNavigate();
  const limitToken = useQuery().get("userLimitConfirmationToken");
  const limitId = useQuery().get("userLimitConfirmationId");
  const moduleLoaded = useSelector((state) => selectModuleLoaded(state, AUTH_CUSTOMER_MODULE_NAME));
  const newLimitsEnabled = (_a = useSelector(selectResponsibleGamblingTools)) == null ? void 0 : _a.limits;
  useEffect(() => {
    if (limitToken && limitId && moduleLoaded) {
      checkLimitToken({ limitToken, limitId });
    }
  }, [checkLimitToken, limitToken, limitId, moduleLoaded]);
  useEffect(() => {
    if (limitTokenSuccess) {
      navigate(newLimitsEnabled ? allowedLinks.responsibleGamblingLimits : allowedLinks.cabinetLimits);
    }
  }, [limitTokenSuccess, newLimitsEnabled]);
};
export {
  useUserLimitToken
};
